export default __webpack_public_path__ + "static/media/back-button.652d6777.svg";